import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../../lib/helpers';

import Button from '../../../../components/Button/Button';

import { ArrowUpIcon, DeleteIcon } from '../../../../images/shapes';

import { useFieldContext, useFormContext } from '../../../form';

const OptionField = ({
  option,
  idx,
  currentValue,
  focusIdx,
  onKeyDown,
  onUp,
  onDown,
  onDelete,
  disabled,
  readonly,
  useOptionsWithLabels,
  testId,
}) => {
  const { t } = useTranslation();
  const form = useFormContext();
  const field = useFieldContext();
  const buttonsDisabled = disabled || readonly;

  return (
    <div className="flex flex-row gap-2">
      {useOptionsWithLabels ? (
        <>
          <form.AppField name={`${field.name}.value`}>
            {(subField) => (
              <subField.CtoCustomField
                properties={{
                  inputType: 'text',
                }}
                schema={{
                  type: 'string',
                }}
                disabled={disabled}
                readonly={readonly}
                onKeyDown={(e) => onKeyDown(e, option, currentValue, idx)}
                placeholder={t('Global.Value')}
                additionalInputLabelClasses="hidden"
                testId={testId}
                {...(focusIdx === idx && { autoFocus: true })}
              />
            )}
          </form.AppField>
          <form.AppField name={`${field.name}.label`}>
            {(subField) => (
              <subField.CtoCustomField
                properties={{
                  inputType: 'text',
                }}
                schema={{
                  type: 'string',
                }}
                disabled={disabled}
                readonly={readonly}
                onKeyDown={(e) => onKeyDown(e, option, currentValue, idx)}
                placeholder={t('Global.Label')}
                additionalInputLabelClasses="hidden"
                testId={testId}
                {...(focusIdx === idx && { autoFocus: true })}
              />
            )}
          </form.AppField>
        </>
      ) : (
        <form.AppField name={field.name}>
          {(subField) => (
            <subField.CtoCustomField
              properties={{
                inputType: 'text',
              }}
              schema={{
                type: 'string',
              }}
              disabled={disabled}
              readonly={readonly}
              onKeyDown={(e) => onKeyDown(e, option, currentValue, idx)}
              additionalInputLabelClasses="hidden"
              testId={testId}
              {...(focusIdx === idx && { autoFocus: true })}
            />
          )}
        </form.AppField>
      )}

      <div className="flex flex-row gap-1 items-center">
        {currentValue.length > 1 && (
          <>
            <Button
              onClick={() => onUp(idx)}
              iconImage={
                <ArrowUpIcon
                  className={twMerge(
                    'h-3 text-slate-400',
                    idx !== 0 && 'hover:text-gray-700',
                  )}
                />
              }
              buttonColor="borderless"
              additionalClasses="w-fit"
              disabled={idx === 0 || buttonsDisabled}
              tabIndex={-1}
              noPaddings
              {...getTestProps(testId, `${field.name}-up`, 'testId')}
            />
            <Button
              onClick={() => onDown(idx)}
              iconImage={
                <ArrowUpIcon
                  className={twMerge(
                    'h-3 rotate-180 text-slate-400',
                    idx !== currentValue.length - 1 && 'hover:text-gray-700',
                  )}
                />
              }
              buttonColor="borderless"
              additionalClasses="w-fit"
              disabled={idx === currentValue.length - 1 || buttonsDisabled}
              tabIndex={-1}
              noPaddings
              {...getTestProps(testId, `${field.name}-down`, 'testId')}
            />
          </>
        )}
        <Button
          onClick={() => onDelete(idx)}
          iconImage={
            <DeleteIcon
              className={twMerge('h-3 text-slate-400 hover:text-gray-700')}
            />
          }
          buttonColor="borderless"
          additionalClasses="w-fit"
          tabIndex={-1}
          disabled={buttonsDisabled}
          noPaddings
          {...getTestProps(testId, `${field.name}-delete`, 'testId')}
        />
      </div>
    </div>
  );
};

export default OptionField;
